var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-loader-top"},[_c('pulse-loader',{attrs:{"loading":this.loading,"color":this.color,"size":this.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }